
import Button from '../../../components/base/Button';

export default function WhyChooseSection() {
  const reasons = [
    {
      icon: 'ri-user-heart-line',
      title: 'Atendimento personalizado e transparente',
      description: 'Cada cliente é único e recebe atenção dedicada em todas as etapas do projeto.'
    },
    {
      icon: 'ri-shield-check-line',
      title: 'Rigor técnico e domínio das normas',
      description: 'Conhecimento profundo das regulamentações e normas técnicas vigentes.'
    },
    {
      icon: 'ri-team-line',
      title: 'Equipe ágil, comprometida e multidisciplinar',
      description: 'Profissionais especializados trabalhando de forma integrada e eficiente.'
    },
    {
      icon: 'ri-star-line',
      title: 'Foco em projetos de alto padrão',
      description: 'Especialização em soluções premium e projetos de excelência.'
    },
    {
      icon: 'ri-chat-3-line',
      title: 'Comunicação clara, sem "engenharês"',
      description: 'Linguagem acessível e transparente em todas as comunicações.'
    },
    {
      icon: 'ri-checkbox-circle-line',
      title: 'Soluções completas integradas',
      description: 'Tudo em um só lugar, do conceito à entrega final do projeto.'
    }
  ];

  return (
    <section className="py-16 bg-white">
      <div className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h2 className="text-2xl md:text-3xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Por que escolher a P&P Engenharia e Arquitetura
          </h2>
          <p className="text-lg text-[#3F3F3F] max-w-3xl mx-auto">
            Diferenciais que fazem da P&P a escolha certa para seus projetos de engenharia e arquitetura.
          </p>
        </div>

        {/* Reasons Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 mb-12">
          {reasons.map((reason, index) => (
            <div 
              key={index}
              className="bg-[#F2F2F2] p-6 rounded-2xl hover:shadow-lg transition-all duration-300 group"
            >
              <div className="w-12 h-12 bg-[#5C1A24] rounded-full flex items-center justify-center mb-4 group-hover:scale-110 transition-transform duration-300">
                <i className={`${reason.icon} text-white text-xl`}></i>
              </div>
              <h3 className="text-lg font-bold text-[#5C1A24] mb-3">
                {reason.title}
              </h3>
              <p className="text-[#3F3F3F] text-sm leading-relaxed">
                {reason.description}
              </p>
            </div>
          ))}
        </div>

        {/* Closing Statement */}
        <div className="bg-[#E8E1DC] p-8 md:p-12 rounded-2xl text-center">
          <h3 className="text-xl md:text-2xl font-bold text-[#5C1A24] mb-4" style={{ fontFamily: '"Playfair Display", serif' }}>
            Na P&P, você tem tudo em um só lugar
          </h3>
          <p className="text-lg text-[#3F3F3F] mb-6 max-w-3xl mx-auto leading-relaxed">
            Do sonho ao documento, do conceito à entrega. Cada detalhe importa, e cada cliente é tratado como único.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Button size="lg">
              <i className="ri-phone-line mr-2"></i>
              Fale conosco
            </Button>
            <Button size="lg" variant="outline">
              <i className="ri-file-text-line mr-2"></i>
              Solicite um orçamento
            </Button>
          </div>
        </div>
      </div>
    </section>
  );
}
